import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface ConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  privacyPolicyUrl?: string;
  label?: string;
  disabled?: boolean;
}

export function ConsentCheckbox({
  checked,
  onChange,
  privacyPolicyUrl = '/privacy',
  label,
  disabled = false,
}: ConsentCheckboxProps) {
  const { t } = useTranslation();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <label className="flex items-start gap-3 cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="mt-0.5 h-5 w-5 rounded border-neutral-300 text-primary-600 focus:ring-primary-500 disabled:cursor-not-allowed"
      />
      <span className="text-sm text-neutral-700">
        {label ?? (
          <>
            <a
              href={privacyPolicyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 underline hover:text-primary-700"
              onClick={(e) => e.stopPropagation()}
            >
              {t('footer.privacy')}
            </a>
            {t('consent_checkbox.text', { ns: 'interview' })}
          </>
        )}
      </span>
    </label>
  );
}
